import React from "react";
import { Link } from "react-router-dom";

const breadcrumbStyle = {
  fontSize: "13px",
};

const linkStyle = {
  color: "#000",
};

const Breadcrumb = ({ breadCrumbItems = [], current }) => {
  return (
    <div style={breadcrumbStyle}>
      <Link to="/" style={linkStyle}>
        Dashboard
      </Link>
      {Boolean(breadCrumbItems.length) &&
        breadCrumbItems.map((item) => {
          return (
            <Link to={item.link} style={linkStyle}>
              &nbsp;/&nbsp;{item.text}
            </Link>
          );
        })}
      <span style={{ color: "#6c757d" }}>&nbsp;/&nbsp;{current}</span>
    </div>
  );
};

export default Breadcrumb;
